const OperatorPolicy = () => {
  const businessDetails = {
    name: "[Your Legal Business Name]",
    address: "[Your Full Registered Address]",
    email: "[Support Email]",
    phone: "[Support Phone]",
  };

  return (
    <div
      style={{
        padding: "40px",
        maxWidth: "900px",
        margin: "0 auto",
        lineHeight: "1.6",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h1>Terms & Policies</h1>
      <p>Last Updated: January 14, 2026</p>

      <nav
        style={{
          marginBottom: "40px",
          display: "flex",
          gap: "15px",
          flexWrap: "wrap",
        }}
      >
        <a href="#contact">Contact Us</a>
        <a href="#shipping">Shipping Policy</a>
        <a href="#refund">Refund Policy</a>
        <a href="#privacy">Privacy Policy</a>
        <a href="#terms">Terms of Service</a>
      </nav>

      <hr />

      <section id="contact">
        <h2>1. Contact Us</h2>
        <p>For any queries regarding our services, please reach out to us:</p>
        <ul>
          <li>
            <strong>Business Name:</strong> {businessDetails.name}
          </li>
          <li>
            <strong>Address:</strong> {businessDetails.address}
          </li>
          <li>
            <strong>Email:</strong> {businessDetails.email}
          </li>
          <li>
            <strong>Phone:</strong> {businessDetails.phone}
          </li>
        </ul>
      </section>

      <section id="shipping">
        <h2>2. Shipping & Delivery Policy</h2>
        <p>
          Orders are typically processed within 2-3 business days. Domestic
          shipping takes 5-7 working days. For digital services, access is
          granted immediately upon successful payment confirmation.
        </p>
      </section>

      <section id="refund">
        <h2>3. Cancellation & Refund Policy</h2>
        <p>
          Cancellations are accepted within 24 hours of order placement. Refunds
          are processed within 5-7 working days to the original payment method
          if the product is defective or the service is not rendered.
        </p>
      </section>

      <section id="privacy">
        <h2>4. Privacy Policy</h2>
        <p>
          We value your privacy. Your personal data (Name, Email, Contact) is
          only used for transaction processing and will never be shared with
          third parties without consent.
        </p>
      </section>

      <section id="terms">
        <h2>5. Terms & Conditions</h2>
        <p>
          By using our website, you agree to our terms. All payments are
          processed via Razorpay. We reserve the right to update these terms at
          any time.
        </p>
      </section>
    </div>
  );
};

export default OperatorPolicy;
